import { async_queue, AsyncMonitor } from './async_monitor'
import { Set, List } from 'immutable'
import i18next from 'i18next'

import { DependenciesState, FieldData, FormState, DependencyResult } from './types'
import { is_valid_postcode, is_valid_phone, is_valid_email, is_valid_date } from './validators'
import * as Model from '../../generated_models'

export let update_elem_in_list = (lst:any[], index:number, elem:any) : any[]=> {
  return lst.map((elem1, index1) => index == index1 ? elem : elem1)
}

export const slugify: (str: string) => string = (str: string) =>
    str
      ? str
          .toString()
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^\w\-]+/g, '')
          .replace(/\-\-+/g, '-')
          .replace(/^-+/, '')
          .replace(/-+$/, '')
      : ''


let get_associated_dependencies = (fieldData:FieldData, formState:FormState) => {
  let associated_dependencies : Set<Model.Dependency> = Set()
  if(formState.form_data.kind == "loaded"){
    formState.form_data.value.steps.forEach(s => {
      s.dependencies.forEach(d => {
        d.dependent_fields.forEach(f => {
          if(f.FieldId == fieldData.Id){
            associated_dependencies = associated_dependencies.add(d.dependency)
          }
        })
      })
    })
  }
  return associated_dependencies.toList()
}

export let are_all_dependencies_met = (formState:FormState) : boolean => {
  let are_dependencies_met = true
  if(formState.form_data.kind == "loaded"){
    formState.dependencies_state.forEach(f => {
      f.forEach(r => {
        if(r.kind=="simple" && r.value == false){ 
          are_dependencies_met = false
        }
        if(r.kind == "async"){
          if(r.value.Result == undefined) return
          if(r.value.Result.kind == "loaded"){ 
            if(r.value.Result.value == false){
              are_dependencies_met = false
            }
          }
          else{
            if(r.value.Result.kind != "unloaded"){ 
              are_dependencies_met = false
            }
          }
        }
      })
    })
  }
  else{
    are_dependencies_met = false
  }
  return are_dependencies_met
}
    
export let areDependenciesMet = (fieldData:FieldData, formState:FormState) : {kind:"yes"} | {kind:"no", messages:List<string>} => {
    
  let associated_dependencies = get_associated_dependencies(fieldData, formState)
  let messages = Set<string>()
  let all_associated_dependencies_met = true
  let dependencies_state =  formState.dependencies_state

  associated_dependencies.forEach(dependency => {
    let dependency_id = dependency.Id
    if(!dependencies_state.has(dependency_id)) return {kind:"no", messages:Set<string>("unassociated dependency")}
    let dependency_fields = dependencies_state.get(dependency_id)
    if(dependency_fields.has(fieldData.Id)){
      dependency_fields.forEach(state => {
        if(state.kind == "simple" && state.value == false) {
          messages = messages.add(dependency.title)
          all_associated_dependencies_met = false
        }
        if(state.kind == "async") {
          if(state.value.Result == undefined) return
          if(state.value.Result.kind != "unloaded") {
            if(state.value.Result.kind == "loaded"){
              if(!state.value.Result.value) {
                messages = messages.add(dependency.title)
                all_associated_dependencies_met = false
              }
            }
            else{
              messages = messages.add(i18next.t("Form:Errors:Checking"))
              all_associated_dependencies_met = false
            }
          }
        }
      })
    }
  })
  
  if(all_associated_dependencies_met) return {kind:"yes"}
  return {kind:"no", messages:messages.toList()}
}


export let is_dependency_met = (dependency:Model.Dependency, formState:FormState) : boolean => {
    
  let messages = List<string>()
  let is_dependency_met = true
  let dependencies_state =  formState.dependencies_state

  let dependency_id = dependency.Id
  if(!dependencies_state.has(dependency_id)) return false
  let dependency_fields = dependencies_state.get(dependency_id)
  
  dependency_fields.forEach(state => {
    if(state.kind == "simple" && state.value == false) {
      messages = messages.push(dependency.title)
      is_dependency_met = false
    }
    if(state.kind == "async") {
      if(state.value.Result.kind != "unloaded") {
        if(state.value.Result.kind == "loaded"){
          if(!state.value.Result.value) {
            messages = messages.push(dependency.title)
            is_dependency_met = false
          }
        }
        else{
          messages = messages.push(i18next.t("Form:Errors:Checking"))
          is_dependency_met = false
        }
      }
    }
  })
  
  return is_dependency_met
}

export let get_dependency_result = (field_id:number, input:string, dependency:Model.Dependency, prevDependenciesStateMonitor?:AsyncMonitor<boolean>) : DependencyResult => {
  if(prevDependenciesStateMonitor == undefined)
    prevDependenciesStateMonitor = async_queue<boolean>({key:`dependency_async_${field_id}_${dependency.Id}`})()

  // if(input == undefined)
  //   input = ""
  let isNumeric = (num:any) => {
    return num != "" && !isNaN(num)
  }
  if(dependency.Kind == "Filled"){
    return {kind:"simple", value:input != undefined && input != ""}
  }
  if(dependency.Kind == "GreaterThan"){
    if(!isNumeric(input) || !isNumeric(dependency.value)) return {kind:"simple", value:false}
    let value = +input
    let test = +dependency.value
    return {kind:"simple", value: input && value > test}
  }
  if(dependency.Kind == "DifferentThan"){
    return {kind:"simple", value: input && input != dependency.value}
  }
  if(dependency.Kind == "IsEmail"){
    return {kind:"simple", value: (input && is_valid_email(input))}
  }
  if(dependency.Kind == "IsNumber"){
    //here we simulate an api call that waits 2 seconds to return a result
    return {kind:"simple", value: (input && isNumeric(input))}
  }
  if (dependency.Kind == "IsPhoneNumber") {
    //Phone check in ./validators in a separate function
    return { kind: "simple", value: input != "" && input && is_valid_phone(input) }
  }
  //Postcode check in ./validators in a separate function
  if (dependency.Kind == "IsPostcode") {
    return { kind: "simple", value: input != "" && input && is_valid_postcode(input) }
  }
  //Date check in ./validators in a separate function
  if (dependency.Kind == "IsDate") {
    return { kind: "simple", value: input != "" && input && is_valid_date(input) }
  }
}



export let update_field_AUX = (fieldData:FieldData, user_input:string, formState:FormState) : { fieldData:FieldData, dependencyState:DependenciesState } => {
  fieldData = {...fieldData, user_input}
  let associated_dependencies = get_associated_dependencies(fieldData, formState)

  let dependencyState : DependenciesState = formState.dependencies_state

  associated_dependencies.forEach(dependency => {
    if(dependencyState.has(dependency.Id)){
      let field_dep_state = dependencyState.get(dependency.Id).get(fieldData.Id)
      let dependency_result = get_dependency_result(fieldData.Id, fieldData.user_input, dependency, field_dep_state && field_dep_state.kind == "async" ? field_dep_state.value : undefined)
      if(dependency_result.kind == "simple"){
        if(dependency_result.value == false){
          dependencyState = dependencyState.set(dependency.Id, 
                                                dependencyState.get(dependency.Id).set(fieldData.Id, dependency_result))
        }
        else{
          dependencyState = dependencyState.set(dependency.Id, 
            dependencyState.get(dependency.Id).remove(fieldData.Id))
        }
      }
      else{
        if(dependency_result.kind == "async"){
          if(dependency_result.value.Result.kind == "loaded"){
            if(dependency_result.value.Result.value == false){
              dependencyState = dependencyState.set(dependency.Id, 
                dependencyState.get(dependency.Id).set(fieldData.Id, dependency_result))
            }
            else{
              dependencyState = dependencyState.set(dependency.Id, 
                dependencyState.get(dependency.Id).remove(fieldData.Id))
            }
          }
          else{ 
            if(dependency_result.value.Result.kind == "unloaded"){
              dependencyState = dependencyState.set(dependency.Id, 
                dependencyState.get(dependency.Id).remove(fieldData.Id))
            }
            else{
              dependencyState = dependencyState.set(dependency.Id, 
                dependencyState.get(dependency.Id).set(fieldData.Id, dependency_result))}
          }
        }
      }
    }
  })

  return {fieldData, dependencyState}
}

export let update_field_file = (fieldData:FieldData, file:File, user_input:string, formState:FormState) : { fieldData:FieldData, dependencyState:DependenciesState } => {
  if (fieldData.Kind == "Attachement")
    fieldData = {...fieldData, file:file, user_input:user_input}
  let associated_dependencies = get_associated_dependencies(fieldData, formState)

  let dependencyState : DependenciesState = formState.dependencies_state

  associated_dependencies.forEach(dependency => {
    if(dependencyState.has(dependency.Id)){
      let field_dep_state = dependencyState.get(dependency.Id).get(fieldData.Id)
      let dependency_result = get_dependency_result(fieldData.Id, fieldData.user_input, dependency, field_dep_state && field_dep_state.kind == "async" ? field_dep_state.value : undefined)
      if(dependency_result.kind == "simple"){
        if(dependency_result.value == false){
          dependencyState = dependencyState.set(dependency.Id, 
                                                dependencyState.get(dependency.Id).set(fieldData.Id, dependency_result))
        }
        else{
          dependencyState = dependencyState.set(dependency.Id, 
            dependencyState.get(dependency.Id).remove(fieldData.Id))
        }
      }
      else{
        if(dependency_result.kind == "async"){
          if(dependency_result.value.Result.kind == "loaded"){
            if(dependency_result.value.Result.value == false){
              dependencyState = dependencyState.set(dependency.Id, 
                dependencyState.get(dependency.Id).set(fieldData.Id, dependency_result))
            }
            else{
              dependencyState = dependencyState.set(dependency.Id, 
                dependencyState.get(dependency.Id).remove(fieldData.Id))
            }
          }
          else{ 
            if(dependency_result.value.Result.kind == "unloaded"){
              dependencyState = dependencyState.set(dependency.Id, 
                dependencyState.get(dependency.Id).remove(fieldData.Id))
            }
            else{
              dependencyState = dependencyState.set(dependency.Id, 
                dependencyState.get(dependency.Id).set(fieldData.Id, dependency_result))}
          }
        }
      }
    }
  })

  return {fieldData, dependencyState}
}

//For the datepicker
import { IDatePickerStrings } from 'office-ui-fabric-react/lib/DatePicker';

export const DayPickerStrings: IDatePickerStrings = {
  months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],

  shortMonths: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],

  days: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],

  shortDays: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],

  goToToday: 'Ga naar vandaag',
  prevMonthAriaLabel: 'Vorige maand',
  nextMonthAriaLabel: 'Volgende maand',
  prevYearAriaLabel: 'Vorig jaar',
  nextYearAriaLabel: 'Volgend jaar',
  closeButtonAriaLabel: 'Sluiten'
};

export const FormatDate = (date: Date): string => {
  return date.getDate() + '-' + (date.getMonth() + 1) + '-' + (date.getFullYear() % 100);
}

export const ParseDateFromString = (value: string): Date => {
  const date = (this as any).state.value || new Date();
  const values = (value || '').trim().split('-');
  const day = values.length > 0 ? Math.max(1, Math.min(31, parseInt(values[0], 10))) : date.getDate();
  const month = values.length > 1 ? Math.max(1, Math.min(12, parseInt(values[1], 10))) - 1 : date.getMonth();
  let year = values.length > 2 ? parseInt(values[2], 10) : date.getFullYear();
  if (year < 100) {
    year += date.getFullYear() - (date.getFullYear() % 100);
  }
  return new Date(year, month, day);
}


export const parseParagraphs = (input: string) : string => 
  `<p>${input.replace(/\n{2}/g, '</p><p>').replace(/[\n]/g, '<br />')}</p>`

export const sortBy = <a,b>(projection: (a:a) => b, array: a[]): a[] =>
  array.sort((x,y) => {
    const px = projection(x)
    const py = projection(y)
    if (px < py) return -1
    if (px > py) return 1
    return 0
  })


  export const StringEmptyOrNull = (s: string) => s == null || s == undefined || s == "" 